import { useEffect, useState } from "react";
import axios from "axios";
import { CATEGORIES } from "@/data/site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CACHE_KEY = "ruta360_categories_cache";
const TTL = 24 * 60 * 60 * 1000;
const TIMEOUT = 8000;
const RETRY_DELAYS = [1000, 2000];

const FALLBACK = CATEGORIES.filter((c) => c !== "Todos").map((nombre, i) => ({
  id: `fallback-${i}`,
  nombre,
  orden: i,
  image: "",
  visible: true,
}));

let categories = FALLBACK;
let fromApi = false;
let running = false;
const listeners = new Set();

try {
  const cached = JSON.parse(localStorage.getItem(CACHE_KEY) || "null");
  if (cached && Array.isArray(cached.data) && cached.data.length > 0 && Date.now() - cached.ts < TTL) {
    categories = cached.data;
  }
} catch {
  /* sin caché */
}

const notify = () => listeners.forEach((l) => l());

const fetchCategories = () => {
  if (running || fromApi) return;
  running = true;
  const attempt = (n) => {
    const preloaded = n === 0 && typeof window !== "undefined" && window.__R360_CATEGORIES;
    const req = preloaded
      ? window.__R360_CATEGORIES.then((data) => ({ data }))
      : axios.get(`${API}/categories`, { timeout: TIMEOUT });
    req
      .then((r) => {
        running = false;
        if (Array.isArray(r.data) && r.data.length > 0) {
          categories = r.data;
          try {
            localStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), data: r.data }));
          } catch {
            /* sin espacio */
          }
        }
        fromApi = true;
        notify();
      })
      .catch(() => {
        if (n < RETRY_DELAYS.length) {
          setTimeout(() => attempt(n + 1), RETRY_DELAYS[n]);
        } else {
          running = false;
        }
      });
  };
  attempt(0);
};

export const useCategories = () => {
  const [, force] = useState(0);
  useEffect(() => {
    const listener = () => force((n) => n + 1);
    listeners.add(listener);
    fetchCategories();
    return () => listeners.delete(listener);
  }, []);
  return { categories, fromApi };
};
